<span kendoTooltip filter="button">
  <button
    kendoButton
    type="button"
    [fillMode]="fillMode"
    class="k-button button-padded {{ primary ? 'k-primary' : '' }} {{ class }}"
    [disabled]="disabled"
    (click)="clickHandler($event)"
    [themeColor]="themeColor"
    [title]="tooltip ? (tooltip | abpLocalization) : ''"
    [attr.data-cy]="title ? (title | abpLocalization) : ('' | cypressName: 'button')">
    @if (showLoader) {
      <kendo-loader [size]="'small'"></kendo-loader>
    }
    @if (icon) {
      <fa-icon [icon]="icon" [size]="size"></fa-icon>
    }
    {{ title | abpLocalization }}
  </button>
</span>
